import { createRoot } from 'react-dom/client';

import { initApm } from '@/apm';
import { App } from '@/app';
import '@/index.css';

initApm();

createRoot(document.getElementById('root')!).render(<App />);
